import { render, staticRenderFns } from "./ClassAttendanceForm.vue?vue&type=template&id=0767fe12"
import script from "./ClassAttendanceForm.vue?vue&type=script&lang=js"
export * from "./ClassAttendanceForm.vue?vue&type=script&lang=js"
import style0 from "./ClassAttendanceForm.vue?vue&type=style&index=0&id=0767fe12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VList,VRadio,VRadioGroup,VRow,VSkeletonLoader})
